import { cn } from "@bindery/ui/lib/utils";
import type { ComponentProps } from "react";

/**
 * `Card` from @bindery/ui, as a `<section>` rather than a `<div>`.
 *
 * The install panel is a labelled, non-modal region, which is what a
 * `<section>` with an accessible name already is. `Card` renders a `<div>`, and
 * giving it `role="region"` is what jsx-a11y/prefer-tag-over-role flags. The
 * generated card.tsx is not edited in place (AGENTS.md, shadcn components), so
 * this copies its element and classes. Keep the class list in step with
 * packages/ui/src/components/ui/card.tsx.
 */
export function CardSection({
  className,
  ...props
}: ComponentProps<"section">) {
  return (
    <section
      data-slot="card"
      className={cn(
        "flex flex-col gap-6 rounded-xl border bg-card py-6 text-card-foreground shadow-sm",
        className,
      )}
      {...props}
    />
  );
}
